import { createSelector } from 'reselect';
import { getAgreements } from '../selectors/submit';

export const validateWarnedAboutResponsibility = createSelector(
  getAgreements,
  ({ warnedAboutResponsibility: { checked } }) => !checked
);

export const validateConsentWithTerms = createSelector(
  getAgreements,
  ({ consentWithTerms: { checked } }) => !checked
);
